<template>
  <div class="shop-menu-agent-mode-order main is-short">
    <div class="wrapper no-scrollbar">
      <div class="subtitle">
        <span @click="close">
          <i class="fa fa-chevron-left" style="margin: 0 4px" />
          {{ $t("TUK Express Order Options") }}
        </span>
      </div>

      <div class="details">
        <p class="key">
          {{ $t("Who will pay the delivery fee?") }}
          <span class="change link" @click="deliveryFeeInfo"
            >{{ currency }}{{ deliveryFee }}</span
          >
        </p>

        <div
          class="notification is-white"
          :class="{ selected: whoPaysDelivery === 'customer' }"
          @click="whoPays('customer')"
        >
          <p>
            <i class="fa fa-user" style="margin-right: 6px" />
            <span class="has-text-weight-medium"
              >Customer Pays Delivery Fee</span
            >
            <i
              class="fa fa-chevron-right fa-lg is-pulled-right"
              style="padding: 6px 0"
            />
          </p>
          <!-- <p><i>Delivery fee will be added to the customer bill</i></p> -->
        </div>
        <div
          class="notification is-white"
          :class="{ selected: whoPaysDelivery === 'shop' }"
          @click="whoPays('shop')"
        >
          <!-- style="background-color: #eee; opacity: 0.7" -->
          <p>
            <i class="fa fa-store-alt" style="margin-right: 6px" />
            <span class="has-text-weight-medium">Shop Pays Delivery fee</span>
            <i
              class="fa fa-chevron-right fa-lg is-pulled-right"
              style="padding: 6px 0"
            />
          </p>
          <!-- <p><i>Delivery fee will be deducted from the shop's</i></p> -->
        </div>

        <collapse-transition>
          <div v-if="whoPaysDelivery" style="margin-top: 10px">
            <p class="key">{{ $t("What is the cost of the goods?") }}</p>
            <div class="notification is-white" @click="enterAmount">
              <p>
                <i class="fa fa-coins" style="margin-right: 6px" />
                <span class="has-text-weight-medium">Enter Price of Goods</span>
                <i
                  class="fa fa-chevron-right fa-lg is-pulled-right"
                  style="padding: 6px 0"
                />
              </p>
              <!-- <p><i>Driver will pay the shop</i></p> -->
            </div>
            <div class="notification is-white" @click="enterItemisedOrder">
              <p>
                <i class="fa fa-list-ol" style="margin-right: 6px" />
                <span class="has-text-weight-medium">Enter Itemised Order</span>
                <i
                  class="fa fa-chevron-right fa-lg is-pulled-right"
                  style="padding: 6px 0"
                />
              </p>
              <!-- <p><i>Shop will collect payment from customer</i></p> -->
            </div>
          </div>
        </collapse-transition>
      </div>

      <!-- <div v-if="payment" style="margin: 16px 0">
        <p class="button is-fullwidth is-success pulse" @click="preSubmit">
          {{ $t("next") }}
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
// import { sounds } from "../functions.js";

export default {
  components: {},
  props: {
    agentModeData: Object, // if editing previously entered data
    business: Object, // transport workflow, should be array
    commerce: Object, // commerce workflow data obj
    currency: String,
    deliveryFee: Number,
  },
  data() {
    return {
      whoPaysDelivery: null,
      costOfGoods: null,
      // old
      payment: null, // user will set payment method
      phoneNumber: null,
      deliveryNotes: null,

      triggered: false,
    };
  },
  computed: {},
  mounted() {
    if (this.agentModeData) {
      this.phoneNumber = this.agentModeData.mobile;
      this.payment = this.agentModeData.payment;
    }
  },
  methods: {
    deliveryFeeInfo() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-motorcycle'></i>&nbsp;Delivery Fee Info</p>
        <p style='margin-bottom:10px'>Delivery fee is calculated based on your store location for pickup and the customer delivery address for dropoff.</p>
        <p><i>Based on the address you provided the delivery fee for this order is 
        <strong>${this.currency}${this.deliveryFee}</strong>
        </i></p>
        </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    whoPays(who) {
      // if (who === "shop") {
      //   var msg = `Shop Pays delivery coming soon!<br>For now use Customer Pays 🙏🏼`;
      //   this.infoToast(msg);
      //   return;
      // }
      this.whoPaysDelivery = who;
    },
    enterAmount() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-coins'></i>&nbsp;Enter price of goods
        </p>
        <p style='margin-bottom:10px'>Enter the cost of the goods to charge the customer.</p>
        <p><i>The delivery fee will be added to this amount.</i></p>
        </div>`,
        input: "number",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Enter",
        inputValidator: (val) => {
          if (!val) return "Enter a valid amount";
        },
      }).then((val) => {
        if (!val.value) return;
        this.submit(val.value);
      });
    },
    enterItemisedOrder() {
      this.submit();
    },
    submit(value) {
      var data = this.payload(value);
      this.log("agent_mode_commerce_order_set_options", data);
      var msg = `🦄 Agent Mode started by ${this.$store.getters.getNameAndNumber} @ ${this.business.name}`;
      this.sendSuperuserNotification(msg);
      this.$emit("submit", data);
    },
    payload(value) {
      return {
        whoPaysDelivery: this.whoPaysDelivery,
        costOfGoods: value,
      };
    },
    showAgentModeInfo() {
      this.$swal({
        html: `<div style='text-align:left'>
<p  font-size:1.2em'>
    <i class='fa fa-headset'></i>&nbsp;TUK Express
</p>
<p style='margin-top:12px'>
    With Agent Mode you can arrange delivery orders for your customers without them needing to place it themselves.
</p>
<p style='margin-top:10px'>
  Perfect for those regular customers who call you on the phone <i class='fa fa-phone fa-sm has-text-grey'></i> 
  or message <i class='far fa-comment-alt fa-sm has-text-grey'></i>  you on LINE <i class='fab fa-line fa-sm has-text-success'></i>
  or Facebook <i class='fab fa-facebook fa-sm has-text-link'></i> .
</p>
<p style='margin-top:10px'>
    Delivery fees start from ฿30 for your customers and we don't charge you anything for the month of May!
</p>
</div>`,
        showCloseButton: true,
        confirmButtonText: "Questions? Message Us!",
      }).then((val) => {
        if (val.value) this.contactFBMessengerSupport();
      });
    },
    setPayment(method) {
      if (method === "shop") {
        var msg = "Shop payment coming soon!<br>For now use Driver Payment 🙏🏼";
        this.infoToast(msg);
        return;
      }
      this.log("set_agent_mode_payment", method);
      this.payment = method;
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  width: 100vw;
  bottom: 0;
  height: calc(100vh - 100px);
  /* background-color: #d4eeffe6; */
  background-color: whitesmoke;
  /* background-color: rgba(245, 245, 245, 0.95); */
  z-index: 21;
  backdrop-filter: blur(12px);
  overflow: hidden;
  /* border-top-left-radius: 25px;
  border-top-right-radius: 25px; */
}

.wrapper {
  padding: 12px;
  text-align: left;
  /* height: 100vh; */
  height: 100%;
  overflow: auto;
}
.subtitle {
  width: 100%;
  display: inline-block;
  /* color: white; */
  opacity: 0.9;
  font-weight: 450;
  /* margin-left: 10px; */
  margin-bottom: 0;
  vertical-align: top;
  line-height: 35px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}
img {
  display: inline-block;
  /* position: absolute; */
  /* left: 12px; */
  height: 35px;
  /* background-color: white; */
}
.notification {
  padding: 6px 12px;
  margin-bottom: 10px;
  border: 1px solid #bbb;
  width: 100%;
}
.amount {
  display: inline-block;
  width: 40px;
}
.key {
  font-weight: 550;
  color: rgba(58, 36, 36, 0.429);
  margin-bottom: 4px;
  margin-left: 4px;
}
.address-notes {
  line-height: 1;
}
.pulse {
  animation: shadow-pulse-gold 1.5s infinite;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px gold;
  }
  100% {
    box-shadow: 0 0 0 8px rgba(255, 217, 0, 0.4);
  }
}
@keyframes shadow-pulse-blue {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 255, 255);
  }
  100% {
    box-shadow: 0 0 0 8px rgba(0, 255, 255, 0.3);
  }
}
.fa-pencil-alt {
  /* color: lightgreen; */
  margin-left: 6px;
}
.details {
  margin: 10px 0;
}
.details p {
  line-height: 1.8em;
}
.choose-one {
  position: absolute;
  right: 10px;
  font-size: 0.85em;
  padding: 4px;
  margin-bottom: 8px;
  color: blue;
  background-color: rgb(255, 242, 0);
  border-radius: 4px;
}

.is-test {
  margin-top: -4px;
  font-size: 0.8em;
}
.grey {
  font-weight: 600;
  color: rgb(151, 151, 151);
  font-size: 0.7em;
  margin-left: 6px;
  /* text-decoration: underline overline; */
}
.link {
  border-bottom: 1px #ccc dotted;
}
.buttons .button {
  margin-bottom: 14px;
}
.buttons .fa {
  font-size: 1.5em;
}
.buttons .button span {
  /* width: 100px; */
  margin-left: 12px;
  /* text-align: right; */
  font-weight: 550;
}
.optional {
  position: absolute;
  right: 18px;
  margin-top: 28px;
  /* left: 116px;
  margin-top: -5px; */
  font-size: 0.7em;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.5);
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.6);
  line-height: 1;
  padding: 2px;
  border-radius: 3px;
}
/* .optional {
  font-size: 0.7em;
  font-weight: 550;
} */

.test-btn {
  float: right;
  padding-top: 4px;
  padding-right: 4px;
  color: grey;
  font-size: 0.8em;
  line-height: 1.4;
}
.change {
  float: right;
  font-weight: 550;
  /* font-size: 0.9em; */
  line-height: 1.5;
  /* margin-top: 4px; */
  color: black;
  margin-right: 8px;
}
.selected {
  background-color: rgb(176, 246, 255);
}
</style>